/* eslint-disable */
import { SET_SAVING_INDIVIDUAl, SET_ERROR_INDIVIDUAl, SET_CURRENCY_INDIVIDUAl, INIT_FORM_INDIVIDUAl, SET_EXCHANGE_RATE_INDIVIDUAl } from '@/constants/mutation_types'
import { CURRENCY_USA } from '@/constants/trans'
import { getExchangeRate } from '@/api/individualTour'
import Vue from 'vue'
/* eslint-disable */
export default {
  namespaced: true,
  state: {
    items: {
      baseCurrency: CURRENCY_USA,
      saleCurrency: CURRENCY_USA,
      exchangeRate: 7.00,
      original_fare: 0,
      total_fare: 0,
      total: [],
      mcoServiceFee: 0,
      mcoService: [],
      hasMco: [],
      fullmco: false,
      itineraryParsed: {
        tour_code: '',
        guest_name: '',
        guest_tel: '',
        travel_date: '',
        airport_pickup: '',
        room_number: '',
        adult_number: ''
      },
      basePrice: {
        payment_method: ''
      }
    },
    saving: false,
    errors: []
  },
  getters: {
    mcoAmount: (state) => state.items.original_fare
  },
  mutations: {
    [SET_SAVING_INDIVIDUAl] (state, saving) {
      state.saving = saving
    },
    [SET_ERROR_INDIVIDUAl] (state, errors) {
      state.errors = state.errors.concat(errors)
    },
    [SET_CURRENCY_INDIVIDUAl] (state, {item, currency}) {
      state.items[`${item}Currency`] = currency
    },
    [INIT_FORM_INDIVIDUAl] (state, itineraryParsed) {
      state.items.itineraryParsed = itineraryParsed
    },
    [SET_EXCHANGE_RATE_INDIVIDUAl] (state, rate) {
      state.items.exchangeRate = rate
    },
    // eslint-disable-next-line
    setOriginalfare (state, originalFare) {
      // eslint-disable-next-line
      state.items.original_fare = originalFare
    },
    setTotalfare (state, totalFare) {
      // eslint-disable-next-line
      // console.log(typeof(state.items.total_fare))
      state.items.total_fare = totalFare
    },
    pushTotal (state, totalFare) {
      state.items.total.push(totalFare)
    },
    modifyTotal (state, {index, totalFare}) {
      state.items.total[index] = totalFare
    },
    deleteTotalfare (state, index) {
      state.items.total.splice(index,1)
    },
    setMcoServiceFee (state, fee) {
      state.items.mcoServiceFee = Number(fee)
    },
    pushMcoServiceFee (state, mcoServiceFee) {
      state.items.mcoService.push(mcoServiceFee)
    },
    hasMco (state, id) {
      state.items.hasMco.push(id)
    },
    deleteMco (state, index) {
      state.items.mcoService.splice(index, 1)
    },
    deleteHasmco (state, index) {
      state.items.hasMco.splice(index, 1)
    },
    setFullmco (state, fullmco) {
      state.items.fullmco = fullmco
    },
    setBaseMethod (state, method) {
      state.items.basePrice.payment_method = method
    },
    initFareState (state) {
      let init = {
        ...state.items,
        baseCurrency: CURRENCY_USA,
        saleCurrency: CURRENCY_USA,
        exchangeRate: 7.00,
        original_fare: 0,
        total_fare: 0,
        total: [],
        mcoServiceFee: 0,
        mcoService: [],
        hasMco: [],
        fullmco: false,
        itineraryParsed: {
          tour_code: '',
          guest_name: '',
          guest_tel: '',
          travel_date: '',
          airport_pickup: '',
          room_number: '',
          adult_number: ''
        },
        basePrice: {
          payment_method: ''
        }
      }
      Vue.set(state, 'items', init)
      console.log(state.items.total_fare)
    },
    // eslint-disable-next-line
    initUpdatePayment (state, {baseCurrency, saleCurrency, exchangeRate, original_fare, total_fare, mco_service_fee}) {
      state.items = {
        ...state.items,
        baseCurrency,
        saleCurrency,
        exchangeRate,
        original_fare,
        total_fare,
        mco_service_fee
      }
    }
  },
  actions: {
    setSaving ({ commit }, saving) {
      commit('SET_SAVING_INDIVIDUAl', saving)
    },
    setError ({ commit }, errors) {
      commit('SET_ERROR_INDIVIDUAl', errors)
    },
    setCurrency ({ commit }, {item, currency}) {
      commit('SET_CURRENCY_INDIVIDUAl', {item, currency})
    },
    setExchangeRate ({ commit }, exchangeRate) {
      commit('SET_EXCHANGE_RATE_INDIVIDUAl', exchangeRate)
    },
    setOriginfare ({commit}, orign) {
      commit('setOriginalfare', orign)
    },
    setTotalfare ({commit}, totalFare) {
      commit('setTotalfare', totalFare)
    },
    pushTotal ({commit}, totalFare) {
      commit('pushTotal', totalFare)
    },
    modifyTotal ({commit}, {index, totalFare}) {
      commit('modifyTotal', {index, totalFare})
    },
    deleteTotalfare ({commit}, index) {
      commit('deleteTotalfare', index)
    },
    setMcoServiceFee ({ state, commit }, fee) {
      commit('setMcoServiceFee', fee)
    },
    pushMcoServiceFee ({ state, commit }, fee) {
      commit('pushMcoServiceFee', fee)
    },
    hasMco ({ state, commit }, id) {
      commit('hasMco', id)
    },
    deleteMco ({ state, commit }, index) {
      commit('deleteMco', index)
    },
    deleteHasmco ({ state, commit }, index) {
      commit('deleteHasmco', index)
    },
    setFullmco ({ commit }, fullmco) {
      commit('setFullmco', fullmco)
    },
    initFormFromItinerary ({ commit }, itineraryParsed) {
      commit('INIT_FORM_INDIVIDUAl', itineraryParsed)
    },
    fetchExchange ({ commit }, base) {
      return new Promise((resolve, reject) => {
        getExchangeRate()
          .then(resp => {
            let rate = resp.data.rates['CNY'].toFixed(2)
            if (!rate) {
              reject(new Error(`Can't get rate`))
              rate = 7.00
            }
            commit('SET_EXCHANGE_RATE_INDIVIDUAl', rate)
            resolve(rate)
          })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/individual.js